import { MingaRoleType } from 'libs/domain';

import { MingaRoleAvatar } from '@shared/constants/roleAvatarFiles';

// added SUPERAMIN as default so users don't recognize it and think they got
// changed to another existing role like student or owner
export const getRoleAvatar = (role: MingaRoleType) => {
  return MingaRoleAvatar[role] || MingaRoleAvatar.SUPERADMIN;
};
